export const HOUR_SCALE = 'hour';

export const DAY_SCALE = 'day';

export const WEEK_SCALE = 'week';

export const MONTH_SCALE = 'month';
